<mat-nav-list [@sidenavWidth]="isMobile ? 'mobile' : (isExpanded ? 'open' : 'closed')">
  <div class='ppu-logo-container mx--sm' [ngClass]="{'mobile-logo-container': isMobile}">
    <div matListItemTitle class='ppu-logo'>
      @if(isExpanded){
        @if(isMobile){
          <div class="mobile-logo-section">
            <img src='./logo/pp-logo-horizontal-white.svg' [ngClass]="isMobile ? 'ppu-logo-mobile' : 'ppu-logo-full'" />
            <div class="mobile-logo-actions">
              <button mat-icon-button (click)="onToggleLanguage()" aria-label="Toggle language">
                <mat-icon class="color--white">language</mat-icon>
              </button>
              <button mat-icon-button (click)="onClose()" aria-label="Close navigation">
                <mat-icon class="color--white">close</mat-icon>
              </button>
            </div>
          </div>
        } @else {
          <img src='./logo/pp-logo-horizontal-white.svg' class="ppu-logo-full" />
        }
      }@else {
        <img src='./logo/pp-logo-head-white.svg' class="ppu-logo-small" />
      }
    </div>
  </div>

  <!-- Mobile User Info -->
  @if(isMobile && isExpanded){
    <div class="px--md mt--md mb--lg">
      <div>
        <div class="color--white bold mb--xs">{{ agentInfo.firstName }} {{ agentInfo.lastName }}</div>
        <div class="color--medium-grey text-small">{{ agentInfo.email }}</div>
        <div class="color--medium-grey text-small">{{ agentInfo.role }}</div>
      </div>
    </div>

    <!-- Mobile Logout Button -->
    <div class="mobile-logout-button p--md">
      <div (click)="onLogout()">
        <span class="icon-logout mr--xs color--white"></span>
        <span class="color--white">{{ 'App.LogOut' | translate }}</span>
      </div>
    </div>
  }

  <mat-list-item (click)='goto(navItem)' *ngFor='let navItem of filteredNavItems' [ngClass]="{ 'active': navItem.active, 'with-spacer': navItem.withSpacer}">
    <mat-icon matListItemIcon><div class="icon-{{navItem.iconClass}}"></div></mat-icon>
    <div matListItemTitle>
      <span>{{ ("App.PageTitles." + navItem.routerLink) | translate }}</span>
    </div>
  </mat-list-item>
</mat-nav-list>
